import { useFormContext } from "react-hook-form";
import LocationSelector from "../../My_MapTools/LocationSelector";
import { ShowOnOffField } from "../../MyShowOnOffButton";

interface MapLocationFieldProps {
  field: {
    name: string; // main map field, e.g., "hotel_location"
    label?: string;
    initialValue?: [number, number] | null;
    latField?: string; // optional, field name for latitude
    lngField?: string; // optional, field name for longitude
    height?: number;   // optional, map height
  };
}

export function MapLocationField({ field }: MapLocationFieldProps) {
  const { getValues } = useFormContext();
  const currentValue = getValues(field.name) as [number, number] | null;

  return (
    <ShowOnOffField
      label={field.label}
      name={field.name}
      initialShow={false}
      initialValue={currentValue ?? field.initialValue ?? null}
      dependentFields={{
        // update lat/lng fields dynamically
        ...(field.latField ? { [field.latField]: (val: [number, number]) => val[0] } : {}),
        ...(field.lngField ? { [field.lngField]: (val: [number, number]) => val[1] } : {}),
      }}
      onText="Hide Map"
      offText={currentValue ? "Change Location" : "Pick Location"}
    >
      {(value, setValue) => (
        <>
          <LocationSelector
            value={value}
            onChange={(lat, lng) => setValue([lat, lng])}
            height={field.height ?? 400}
          />
          {value && (
            <div className="mt-2 text-sm text-gray-700 dark:text-gray-300">
              📍 Selected: {value[0].toFixed(5)}, {value[1].toFixed(5)}
            </div>
          )}
        </>
      )}
    </ShowOnOffField>
  );
}